import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { STARTER_TAGS } from '@hoopify/shared';
import { api } from '../lib/api';

/** Tap tags on or off; add your own. Suggestions are the starter list plus tags you've used. */
export function TagPicker({ value: given, onChange, compact }: { value: string[] | null | undefined; onChange: (tags: string[]) => void; compact?: boolean }) {
  const value = given ?? [];
  const all = useQuery({ queryKey: ['drill-tags'], queryFn: () => api.get<string[]>('/drills/tags'), staleTime: 60_000 });
  const [custom, setCustom] = useState('');
  const has = (t: string) => value.some((v) => v.toLowerCase() === t.toLowerCase());
  const toggle = (t: string) => onChange(has(t) ? value.filter((v) => v.toLowerCase() !== t.toLowerCase()) : [...value, t].slice(0, 10));
  const add = () => {
    const t = custom.trim().slice(0, 30);
    if (t && !has(t)) onChange([...value, t].slice(0, 10));
    setCustom('');
  };
  const suggestions = [...new Set([...(all.data ?? STARTER_TAGS), ...value])];
  const size = compact ? 'px-2 py-0.5 text-[12px]' : 'px-2.5 py-0.5 text-[13px]';
  return (
    <div>
      <div className="flex flex-wrap gap-1.5">
        {suggestions.map((t) => (
          <button
            type="button"
            key={t}
            onClick={() => toggle(t)}
            aria-pressed={has(t)}
            className={`rounded-full border ${size} ${has(t) ? 'border-action bg-action text-action-ink' : 'border-line-strong text-muted hover:text-ink'}`}
          >
            {t}
          </button>
        ))}
      </div>
      <div className="mt-2 flex gap-2">
        <input
          className="field-input max-w-[200px] py-1.5 text-[14px]"
          placeholder="Add your own"
          value={custom}
          maxLength={30}
          onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
          aria-label="New tag"
        />
        <button type="button" className="btn-secondary py-1.5" onClick={add} disabled={!custom.trim()}>
          Add
        </button>
      </div>
    </div>
  );
}
